import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import ApiTrackingCtrl from "../api/ApiTrackingCtrl";

function getSessionId() {
    let id = sessionStorage.getItem("tracking_session_id");
    if (!id) {
        id = uuidv4();
        sessionStorage.setItem("tracking_session_id", id);
    }
    return id;
}

function parseQueryParams(search) {
    const params = {};
    const sp = new URLSearchParams(search);
    sp.forEach((value, key) => { params[key] = value; });
    return params;
}

/**
 * Hook à placer une seule fois dans le composant racine (ex: RouteContainer ou App).
 * Envoie un événement de tracking à chaque changement de route.
 * @param {object|null} user - L'utilisateur connecté (doit avoir .login)
 */
export default function usePageTracking(user) {
    const location = useLocation();
    const lastPath = useRef(null);

    useEffect(() => {
        const path = location.pathname;
        const userId = user?.login || "anonymous";
        const key = userId + "::" + path + location.search;

        // Ne pas re-tracker la même page + même user
        if (lastPath.current === key) return;
        lastPath.current = key;

        ApiTrackingCtrl.track({
            sessionId: getSessionId(),
            userId,
            path,
            queryParams: parseQueryParams(location.search),
            userAgent: navigator.userAgent,
        }).catch(() => { /* silencieux — le tracking ne doit pas bloquer l'UX */ });
    }, [location, user]);
}
